import { appActions } from 'state/modules/app';
import Cookies from 'universal-cookie';

export default class LogoutTimer {
  SESSION_EXPIRY = 'sessionExpiry';

  constructor(store) {
    this.logoutCheck = this.logoutCheck.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.clearLogout = this.clearLogout.bind(this);
    this.setInterval = this.setInterval.bind(this);
    this.timeOutCall = null;
    this.interval = 60000; // 1 min
    this.logOutTime = 1800000; // 30 min
    this.store = store;
    this.loggedOut = false;
    this.timeOutCall = setInterval(this.logoutCheck, this.interval);
    this.cookies = new Cookies();
  }

  setInterval(interval) {
    this.interval = interval;
  }

  setLogOutTime(logOutTime) {
    this.logOutTime = logOutTime;
  }

  resetTimer() {
    if (typeof Storage !== 'undefined') {
      localStorage.setItem('timeOut', Date.now());
    } else {
      // Sorry! No Web Storage support..
    }
  }

  logoutCheck() {
    if (this.cookies.get(this.SESSION_EXPIRY)) {
      this.logOutTime = this.cookies.get(this.SESSION_EXPIRY);
    }

    if (Date.now() - localStorage.timeOut > this.logOutTime) {
      if (
        window.location.pathname !== '/Login' &&
        window.location.pathname !== '/Authenticate' &&
        window.location.pathname !== '/RequestPasswordReset'
      ) {
        this.loggedOut = true;
        this.store.dispatch(appActions.loginRedirect());
      }
    } else if (this.loggedOut) {
      this.clearLogout();
    }
  }

  clearLogout() {
    this.loggedOut = false;
    this.store.dispatch(appActions.clearLogin());
  }
}
